// Token expiration time in milliseconds (30 minutes)
const TOKEN_EXPIRATION_TIME = 30 * 60 * 1000;
// Inactivity timeout in milliseconds (10 minutes)
const INACTIVITY_TIMEOUT = 10 * 60 * 1000;

let inactivityTimer = null;

// Function to reset the inactivity timer
const resetInactivityTimer = () => {
    if (inactivityTimer) {
        clearTimeout(inactivityTimer);
    }
    
    inactivityTimer = setTimeout(() => {
        // Clear token when user is inactive
        clearToken();
        // Redirect to login page if we're in a browser environment
        if (typeof window !== 'undefined') {
            window.location.href = '/';
        }
    }, INACTIVITY_TIMEOUT);
};

// Function to start monitoring user activity
const startActivityMonitoring = () => {
    // Reset timer on user activity
    const activityEvents = [
        'mousedown',
        'mousemove',
        'keypress',
        'scroll',
        'touchstart',
        'click'
    ];

    activityEvents.forEach(event => {
        window.addEventListener(event, resetInactivityTimer, true);
    });

    // Initial timer start
    resetInactivityTimer();
};

// Function to stop monitoring user activity
const stopActivityMonitoring = () => {
    if (inactivityTimer) {
        clearTimeout(inactivityTimer);
    }

    const activityEvents = [
        'mousedown',
        'mousemove',
        'keypress',
        'scroll',
        'touchstart',
        'click'
    ];

    activityEvents.forEach(event => {
        window.removeEventListener(event, resetInactivityTimer, true);
    });
};

export const setToken = (token) => {
    const expirationTime = new Date().getTime() + TOKEN_EXPIRATION_TIME;
    localStorage.setItem('token', token);
    localStorage.setItem('tokenExpiration', expirationTime.toString());
    
    // Start monitoring user activity when token is set
    if (typeof window !== 'undefined') {
        startActivityMonitoring();
    }
};

export const getToken = () => {
    const token = localStorage.getItem('token');
    const expirationTime = localStorage.getItem('tokenExpiration');
    
    if (!token || !expirationTime) {
        return null;
    }

    // Check if token has expired
    if (new Date().getTime() > parseInt(expirationTime)) {
        clearToken();
        return null;
    }

    // Reset inactivity timer when token is accessed
    if (typeof window !== 'undefined') {
        resetInactivityTimer();
    }

    return token;
};

export const clearToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiration');
    
    // Stop monitoring user activity when token is cleared
    if (typeof window !== 'undefined') {
        stopActivityMonitoring();
    }
};

export const isTokenValid = () => {
    return getToken() !== null;
};

// Function to check token validity and redirect if needed
export const checkTokenAndRedirect = (navigate) => {
    if (!isTokenValid()) {
        navigate('/');
        return false;
    }
    return true;
};

// Function to manually reset the inactivity timer
export const resetUserActivity = () => {
    if (typeof window !== 'undefined') {
        resetInactivityTimer();
    }
}; 